// extracted by mini-css-extract-plugin
module.exports = {"entreeSection":"CategorySection_entreeSection__wrDbT","sectionTitle":"CategorySection_sectionTitle__aVEPx","itemsContainer":"CategorySection_itemsContainer__qDQ50"};